import { ReactNode, useState } from "react";
import { Layout } from "./Layout";
import { Building, Calendar, CreditCard, PlusCircle, CalendarRange, Link as LinkIcon, Airplay, DollarSign, Sparkles, MessagesSquare, BarChart3, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useLocation, Link } from "wouter";
import { Sidebar } from "@/components/layout/Sidebar";
import logo from '@/assets/staymiddle-logo.png';

interface ManagerLayoutProps {
  children: ReactNode;
}

export default function ManagerLayout({ children }: ManagerLayoutProps) {
  const [location] = useLocation();
  
  // Sidebar navigation items
  const navItems = [
    {
      label: "Dashboard",
      href: "/manager/dashboard",
      icon: <BarChart3 className="w-5 h-5 mr-2" />,
      active: location === "/manager/dashboard",
    },
    {
      label: "Properties",
      href: "/manager/properties",
      icon: <Building className="w-5 h-5 mr-2" />,
      active: location === "/manager/properties",
    },

    {
      label: "Calendar & Pricing",
      href: "/manager/calendar",
      icon: <CalendarRange className="w-5 h-5 mr-2" />,
      active: location === "/manager/calendar",
    },
    {
      label: "Bookings",
      href: "/manager/bookings",
      icon: <Airplay className="w-5 h-5 mr-2" />,
      active: location === "/manager/bookings",
    },
    {
      label: "Earnings",
      href: "/manager/earnings",
      icon: <DollarSign className="w-5 h-5 mr-2" />,
      active: location === "/manager/earnings",
    },
    {
      label: "Property Links",
      href: "/manager/links",
      icon: <LinkIcon className="w-5 h-5 mr-2" />,
      active: location === "/manager/links",
    },
    {
      label: "Community",
      href: "/manager/community",
      icon: <MessagesSquare className="w-5 h-5 mr-2" />,
      active: location === "/manager/community" || location.startsWith("/manager/community/"),
    },
    {
      label: "Stripe Connect",
      href: "/stripe-connect",
      icon: <CreditCard className="w-5 h-5 mr-2" />,
      active: location === "/stripe-connect",
    },
    {
      label: "Settings",
      href: "/settings",
      icon: <Settings className="w-5 h-5 mr-2" />,
      active: location === "/manager/settings",
    },
  ];

  // Collapsed state for sidebar
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen">
      <Sidebar navItems={navItems} collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout>{children}</Layout>
    </div>
  );
}